import { forwardRef } from "react";
import { type LucideProps } from "lucide-react";

export const PickleballIcon = forwardRef<SVGSVGElement, LucideProps>(
  ({ color = "currentColor", size = 24, strokeWidth = 2, className, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="7" r="1.5" fill={color} stroke="none" />
      <circle cx="12" cy="17" r="1.5" fill={color} stroke="none" />
      <circle cx="7" cy="12" r="1.5" fill={color} stroke="none" />
      <circle cx="17" cy="12" r="1.5" fill={color} stroke="none" />
      <circle cx="12" cy="12" r="1.5" fill={color} stroke="none" />
    </svg>
  ),
);
PickleballIcon.displayName = "PickleballIcon";
